import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data, Editors } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import axios from 'axios';

import { isVAK } from '../../actions/root_url';
import { DUPLICATE_CUSTOMER_URL } from '../../actions/url'


export class DuplicateToCompanyModal extends Component {
    constructor() {
        super();
        this.state = {
            companies: [],
            isLoading: false,
            customerId: '',
        }
    }

    componentDidMount() {
        if (isVAK && this.props.companies) {
            this.setState({
                companies: this.props.companies,
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        if (isVAK && nextProps.companies != this.props.companies) {
            this.setState({
                companies: nextProps.companies || [],
            })
        }
    }

    handleOnClick = (ind, event) => {
        let cpCompanies = [...this.state.companies];
        let companies = cpCompanies.map((item, index) => {
            if (ind == index) {
                return { ...item, isChecked: event.target.checked }
            } else {
                return { ...item }
            }
        })
        this.setState({
            companies,
        })
    }

    handleOnSave = () => {
        let tocompany = [];
        this.state.companies.map(item => {
            if (item.isChecked) {
                tocompany.push(item.value);
            }
        })
        if (tocompany.length == 0) {
            alert('Please select a company!')
            return
        }
        let customerid = [this.props.customerId];
        this.setState({
            isLoading: true,
        });
        axios.post(DUPLICATE_CUSTOMER_URL, {
            customerid,
            tocompany,
        }, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }).then(response => {
            this.setState({
                isLoading: false,
            });
            alert('Success')
            this.props.onClose();
        }).catch(() => {
            this.setState({
                isLoading: false,
            });
        })
    }

    render() {
        const {
        } = this.props;

        const {
        } = this.state;

        return (
            <div>
                <Row>
                    <Col style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        {this.state.companies.map((item, index) => {
                            return <div style={{ width: '160px' }}>
                                <input
                                    id="cell-checkbox"
                                    type="checkbox"

                                    checked={item.isChecked}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        this.handleOnClick(index, event);
                                    }}
                                />
                                <span>
                                    {item.label}
                                </span>
                            </div>
                        })}
                    </Col>
                </Row>

                <Row className="centerStyle" style={{ marginTop: '20px' }}>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.handleOnSave();
                        }}
                        disabled={this.state.isLoading}
                    >
                        <Translate value="save" />
                    </Button>
                    <Button
                        bsStyle="danger"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.props.onClose();
                        }}
                    >
                        <Translate value="cancel" />
                    </Button>
                </Row>
            </div>
        );
    }
}

export default DuplicateToCompanyModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Customers/DuplicateToCompanyModal.jsx